import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import SpotFormWizard from "../components/spotForm/SpotFormWizard";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

function EditSpotSuggestionShell({ children }) {
    return (
        <div className="blog-page-root">
            <div className="blog-page-inner new-spot-glass-inner">
                <article className="cms-page-panel new-spot-glass-panel">
                    {children}
                </article>
            </div>
        </div>
    );
}

export default function EditSpotSuggestionPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [spot, setSpot] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        setMessage("");
        try {
            const { data } = await axios.get(`${API_BASE_URL}/api/spots/${id}`);
            setSpot(data);
        } catch {
            setMessage("Не удалось загрузить точку.");
            setSpot(null);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        load();
    }, [load]);

    if (loading) {
        return (
            <EditSpotSuggestionShell>
                <p className="cms-page-loading">Загрузка...</p>
            </EditSpotSuggestionShell>
        );
    }

    if (!spot) {
        return (
            <EditSpotSuggestionShell>
                <p className="cms-page-loading">{message || "Точка не найдена."}</p>
                <p className="cms-page-loading" style={{ marginTop: 12 }}>
                    <Link to="/map">К карте</Link>
                </p>
            </EditSpotSuggestionShell>
        );
    }

    const spotLabel = spot.title || spot.place?.name || spot.name || `Точка #${id}`;

    return (
        <EditSpotSuggestionShell>
            <div className="spot-page__title-row">
                <div>
                    <h1 className="new-spot-glass-title">Предложить изменения точки</h1>
                    <p className="new-spot-glass-subtitle">{spotLabel}</p>
                </div>
                <Link className="btn-outline" to={`/spots/${id}`}>
                    К странице точки
                </Link>
            </div>
            <SpotFormWizard
                mode="editSuggestion"
                spotId={id}
                initialSpot={spot}
                onSubmitSuccess={() => setTimeout(() => navigate(`/spots/${id}`), 400)}
            />
        </EditSpotSuggestionShell>
    );
}
